var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6284_26884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15685 6.34315L1.38909 8.11091L9.16726 15.8891L10.935 14.1213L3.15685 6.34315ZM17.6525 3.16117L15.8848 1.3934L8.1066 9.17157L9.87437 10.9393L17.6525 3.16117ZM3.15685 17.6569L1.38909 15.8891L4.21751 13.0607L5.98528 14.8284L3.15685 17.6569ZM8.1066 1.3934L6.33883 3.16117L9.16726 5.98959L10.935 4.22183L8.1066 1.3934ZM13.0563 9.87868L14.8241 8.11091L22.6023 15.8891L20.8345 17.6569L13.0563 9.87868ZM15.8848 14.8284L14.117 13.0607L6.33883 20.8388L8.1066 22.6066L15.8848 14.8284ZM19.7739 10.9393L18.0061 9.17157L20.8345 6.34315L22.6023 8.11091L19.7739 10.9393ZM14.8241 18.0104L13.0563 19.7782L15.8848 22.6066L17.6525 20.8388L14.8241 18.0104Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6284_26884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/icon-products.048ece58bea14905d31d4820528d819d.svg";
export { ForwardRef as ReactComponent };